<template>
  <dl v-if="hasKeyPairValues">
    <template v-for="entry in entries">
      <template
        v-if="entry.__typename === 'ZipCityField' && !!getEntryValue(entry)"
      >
        <dt :key="`${entry.id}-zip-term`">
          {{ $t(`${getEntryLabel(entry)}.zip`) }}
        </dt>
        <dd :key="`${entry.id}-zip-def`">
          {{ getEntryValue(entry).zip }}
        </dd>

        <dt :key="`${entry.id}-city-term`">
          {{ $t(`${getEntryLabel(entry)}.city`) }}
        </dt>
        <dd :key="`${entry.id}-city-def`">
          {{ getEntryValue(entry).city }}
        </dd>
      </template>
      <template
        v-else-if="
          entry.__typename === 'LocationsField' && !!getEntryValue(entry)
        "
      >
        <dt :key="`${entry.id}-locations-term`">
          {{ $t(`${getEntryLabel(entry)}`) }}
        </dt>
        <dd :key="`${entry.id}-locations-def`">
          <ol>
            <li
              v-for="item in entry.value"
              :key="`${item.country}-${item.city}-${item.street}-${item.houseNumber}`"
            >
              <span>{{ item.street }} {{ item.houseNumber }}</span>
              <br />
              <span>{{ item.zip }} {{ item.city }}</span>
              <br />
              <span>{{ allCountries[$i18n.locale][item.country] }}</span>
            </li>
          </ol>
        </dd>
      </template>
      <template v-else>
        <template v-if="!!getEntryValue(entry)">
          <dt :key="`${entry.id}-term`">
            {{ $t(`${getEntryLabel(entry)}`) }}
          </dt>
          <dd :key="`${entry.id}-def`">
            {{ getEntryValue(entry) }}
          </dd>
        </template>
      </template>
    </template>
  </dl>
  <ul v-else>
    <li v-for="entry in entries" :key="entry.id">
      {{ getSingleLine(entry) }}
    </li>
  </ul>
</template>

<script>
import { format } from 'date-fns'
import countrylist from '../DX-LocationsFieldAdapter/countries.json'

export default {
  name: 'SummaryItemEntries',
  props: {
    entries: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    hasKeyPairValues() {
      return this.entries.every(
        (entry) =>
          !['ContentItem', 'ModuleSelectionField'].includes(
            // eslint-disable-next-line no-underscore-dangle
            entry.__typename,
          ),
      )
    },
    allCountries() {
      return countrylist
    },
  },
  methods: {
    getEntryLabel(entry) {
      if (entry.source) {
        return `attributes.${entry.source.key}.${entry.source.originalId}.label`
      }

      return ''
    },

    // eslint-disable-next-line complexity
    getEntryValue(entry) {
      const { value, __typename } = entry
      if (value === null) {
        return ''
      }
      if (__typename === 'DateField') {
        return format(new Date(value), entry.pattern || 'DD.MM.YYYY')
      }
      if (__typename === 'ZipCityField') {
        return value
      }
      if (Array.isArray(value)) {
        return value.length > 0 ? value[0] : ''
      }
      if (typeof value === 'boolean') {
        return value ? this.$t('yes') : this.$t('no')
      }
      return value
    },

    getSingleLine(entry) {
      if (entry.__typename === 'ModuleSelectionField') {
        return this.$t(`modules.${entry.source.key}.label`)
      }

      if (entry.id === 'summary-variant-item') {
        return this.$t('variantName')
      }

      return entry.richText || entry.id
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@sumcumo/dextra-frontend-component-lib/dist/assets/styles/variables/colors';
@import '~@sumcumo/dextra-frontend-component-lib/dist/assets/styles/variables/typo';
@import '~@sumcumo/dextra-frontend-component-lib/dist/assets/styles/functions/px-to-rem';

.test {
  zoom: 1;
}

ul {
  padding-left: 0;
  list-style: none;

  li {
    color: $black-clr;
    font-family: $font-family-heavy;
    font-size: rem(16);
    line-height: rem(24);
  }
}

dt,
dd {
  color: $black-clr;
  font-size: rem(16);
  line-height: rem(24);
}

dt {
  font-family: $font-family-roman;
  font-weight: 400;
}

dd {
  font-family: $font-family-heavy;
}

ol {
  padding-left: rem(20);

  li {
    color: $black-clr;
    font-family: $font-family-heavy;
    font-size: rem(16);
    line-height: rem(24);
  }
}
</style>
